export enum PaymentTypeEnum {
  PAYMENT_INCL_GST = 1,
  PAYMENT_EXCL_GST = 2,
  GST = 3
}
export type PaymentType = {
  [key in PaymentTypeEnum]: string;
};

export const PAYMENT_TYPE_LIST: PaymentType = {
  [PaymentTypeEnum.PAYMENT_INCL_GST]: 'Payment Incl. Tax',
  [PaymentTypeEnum.PAYMENT_EXCL_GST]: 'Payment Excl. Tax',
  [PaymentTypeEnum.GST]: 'Tax'
};
